import styled from 'styled-components';

export const Quark = `
  font-family: quarkbold;
  color: #000;
`;

const BoostrapRow = `
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.65);
  font-family: "Monospaced Number", "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 21px;
  margin-left: -15px;
  margin-right: -15px;

  &::after {
    content: "";
    clear: both;
    display: table; 
  }
`;

export const H1Title = styled.h1`
  ${Quark}
  color: rgb(51, 51, 51);
`;

export const H2Title = styled.h2`
  ${Quark}
  color: rgb(51, 51, 51);
`;

export const H3Title = styled.h3`
  ${Quark}
  color: rgb(51, 51, 51);
`;

export const Content = styled.section`
  margin-top: 20px;
`;

export const DivMargin15 = styled.div`
  ${BoostrapRow}
  margin-bottom: 15px;
`;

export const ImageBlock = styled.img`
  display: inline-block;
  max-width: 100%;
  height: auto;
`;



// WEBPACK FOOTER //
// ./resources/assets/js/containers/styles.js